import { getDefaultClient } from '../../../client/defaultClient';
import { refreshAuth } from '../../user/refreshAuth';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type RevokeWaasDelegationParams = {
  password?: string;
  walletAccount: WalletAccount;
};

/**
 * Revokes the delegation of a WaaS wallet account.
 *
 * @param params.walletAccount - The WaaS wallet account to revoke delegation for.
 * @param [params.password] - Optional password for delegation operations.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the delegation is revoked.
 */
export const revokeWaasDelegation = async (
  { password, walletAccount }: RevokeWaasDelegationParams,
  client = getDefaultClient()
): Promise<void> => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  await provider.revokeDelegation({
    password,
    walletAccount,
  });

  await refreshAuth(client);
};
